import { FC, useState } from "react";

import {
  MuiBox,
  MuiButtonPrimary,
  MuiButtonSecondary,
  MuiButtonTertiary,
} from "../../../../components";
import { useSiteCore } from "../../../../hooks/useSiteCore";
import { CreateProjectFooterWrapper } from "./CreateProjectFooter.style";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { CancelFieldModal } from "../../../createProgramTemplate/components/cancelFieldModal/CancelFieldModal";

interface CreateProjectFooterProps {
  pageId: string;
  onConfirmClick: () => void;
  handleNavigateBack: () => void;
  confirmButtonText: string;
  isFiledUpdated: boolean;
  handleBackButtonClick?: () => void;
  isShowBackButton?: boolean;
  cancelMessage?: string;
  cancelButtonText?: string;
  confirmationTitle?: string;
}

export const CreateProjectFooter: FC<CreateProjectFooterProps> = ({
  pageId,
  onConfirmClick,
  handleNavigateBack,
  isFiledUpdated,
  confirmButtonText,
  handleBackButtonClick,
  isShowBackButton = false,
  confirmationTitle,
  cancelButtonText,
  cancelMessage,
}) => {
  const { commonLabels } = useSiteCore();
  const [showCancelModal, setShowCancelModal] = useState(false);

  const handleModalClose = () => {
    setShowCancelModal(false);
  };

  const handleCancelButton = () => {
    if (isFiledUpdated) {
      setShowCancelModal(true);
    } else {
      handleNavigateBack();
    }
  };

  const handleOkClick = () => {
    handleModalClose();
    handleNavigateBack();
  };

  return (
    <CreateProjectFooterWrapper>
      <MuiBox className="back-button">
        {isShowBackButton && (
          <MuiButtonTertiary
            data-testid={`${pageId}-back`}
            onClick={handleBackButtonClick}
          >
            <ArrowBackIosIcon />
            {commonLabels.back}
          </MuiButtonTertiary>
        )}
      </MuiBox>
      <MuiBox>
        <MuiButtonSecondary
          id={`${pageId}-cancel`}
          onClick={handleCancelButton}
        >
          {cancelButtonText ?? commonLabels.cancel}
        </MuiButtonSecondary>
        <MuiButtonPrimary onClick={onConfirmClick} id={`${pageId}-confirm`}>
          {confirmButtonText}
        </MuiButtonPrimary>
      </MuiBox>
      {showCancelModal && (
        <CancelFieldModal
          showModal={showCancelModal}
          handleModalClose={handleModalClose}
          handlePrimaryButtonClick={handleOkClick}
          cancelMessage={cancelMessage}
          title={confirmationTitle}
        />
      )}
    </CreateProjectFooterWrapper>
  );
};
